import { LinkListElementElementModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import FileLink from '@shared/components/FileLink.tsx';

interface ILinkListProps {
    element: LinkListElementElementModel;
}

const LinkList = ({ element }: ILinkListProps) => {
    return (
        <div className='click-item p-3'>
            <div className='click-item-body'>
                <h5 className='click-item-title'>{element.properties?.heading}</h5>
                {element.properties?.text?.markup && (
                    <div
                        className='click-item-text mb-4'
                        dangerouslySetInnerHTML={{ __html: element.properties.text.markup }}
                    />
                )}
                {element.properties?.linkList && (
                    <div className='mb-3'>
                        {element.properties.linkList.map((link, key) => {
                            if (!link || link.url === null) return null;
                            return (
                                <FileLink
                                    key={key}
                                    url={link.url}
                                    title={link.title ?? ''}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};
export default LinkList;
